export * from './baMenu.service';



// WEBPACK FOOTER //
// /app/src/app/theme/services/baMenu/index.ts